import React, { FC } from 'react';
import { Grid, InputAdornment, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { useFormikContext } from 'formik';

import { CustomSVG, PaddedPaper, ValidatedSwitch, ValidatedTextField } from 'components';
import { ContentFragment } from 'api';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    'label + &': {
      marginTop: 0,
    },
  },
  safe: {
    color: theme.palette.grey[600],
  },
  warning: {
    color: theme.palette.warning.main,
  },
  error: {
    color: theme.palette.error.main,
  },
}));

const NotifyTeam: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { values } = useFormikContext<ContentFragment>();
  const { is_important } = values; // need backend update

  function renderAdornment() {
    const limit = 160;
    const length = 0; // need backend update
    const difference = limit - length;
    const className = classNames({
      [classes.safe]: difference >= 21,
      [classes.warning]: difference <= 20,
      [classes.error]: difference < 0,
    });

    return (
      <InputAdornment variant="filled" position="end">
        <Typography className={className}>
          {length}/{limit}
        </Typography>
      </InputAdornment>
    );
  }

  return (
    <Grid item xs={12}>
      <PaddedPaper square padding={20}>
        <Grid container alignItems="flex-start" wrap="nowrap">
          <Grid item xs={1}>
            <CustomSVG name="flag" color={is_important ? 'inherit' : 'disabled'} />
          </Grid>
          <Grid item container direction="column" xs={10}>
            <Grid item>
              <Typography variant="subtitle1">{t('posting:notifyTeam')}</Typography>
            </Grid>
            <Grid item>
              <Typography color="textSecondary">{t('posting:guidelineNotifyTeam')}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={1}>
            <ValidatedSwitch name="is_important" labelPlacement="bottom" />
          </Grid>
        </Grid>
        {is_important && (
          <Grid container className={classes.root}>
            <Grid item xs={1} />
            <Grid item xs={10}>
              <ValidatedTextField
                name="need-backend-update"
                i18nKey="posting:commentary"
                TextFieldProps={{ margin: 'none', multiline: true, rows: 2 }}
                InputProps={{
                  classes: { formControl: classes.formControl },
                  endAdornment: renderAdornment(),
                }}
                onChange={(event, onChange) => onChange(event)}
              />
            </Grid>
          </Grid>
        )}
      </PaddedPaper>
    </Grid>
  );
};

export default NotifyTeam;
